import { load, store } from "../localStorage"
import { logEvent, logEventBySelector, logEvents } from "../logger"

const INITIAL_PAYMENT_METHOD = "primer"

export default (getView) => () => ({
  ...getView(),

  error: null,
  activePaymentMethod: null,

  selectPaymentMethod(paymentMethod) {
    if (!this.activePaymentMethod || paymentMethod !== this.activePaymentMethod) {
      this.error = null
    }

    const globalData = load("data")

    const updatedValues = {
      ...globalData.values,
      paymentMethod,
    }

    // Update local storage
    store("data", {
      ...globalData,
      values: updatedValues,
    })

    // Update app state
    this.store.values.paymentMethod = paymentMethod

    this.activePaymentMethod = paymentMethod
  },

  paymentMethodClicked(paymentMethod) {
    if (this.activePaymentMethod && paymentMethod !== this.activePaymentMethod) {
      const eventName = `payment-method-${paymentMethod}-selected`
      window.analytics.track(window.getEventName(eventName), { paymentMethod })
    }

    this.selectPaymentMethod(paymentMethod)
  },

  isActive(paymentMethod) {
    return paymentMethod === this.activePaymentMethod
  },

  onInit() {
    const initialPaymentMethod =
      pipelineConfig.paymentMethods.find((paymode) => paymode === INITIAL_PAYMENT_METHOD) ||
      paymodes[0]

    this.selectPaymentMethod(initialPaymentMethod)

    this.store.trackVisitCheckout()

    if (typeof window.Primer !== "undefined") {
      logEvent(logEvents.primerSdkInitialized, {
        orderId: this.store?.values?.id,
        userId: this.store?.values?.userId,
      })
    }

    logEvent(logEvents.checkoutStarted, {
      orderId: this.store?.values?.id,
      userId: this.store?.values?.userId,
    })
  },
})
